import { Injectable } from '@angular/core';
import { AttachYCState, BaseYCService } from '@yourcause/common/state';
import { Observable, tap } from 'rxjs';
import { NonprofitFeatureFlagsState } from './nonprofit-feature-flags.state';
import { NonprofitFeatureFlagsResources } from './nonprofit-feature-flags.resources';
import { NonprofitFeatureFlag } from './models';
import { FeatureFlagName } from '@core/typings/feature-flag.typing';

/**
 * Nonprofit Feature Flag Service.
 */
@AttachYCState(NonprofitFeatureFlagsState)
@Injectable({ providedIn: 'root' })
export class NonprofitFeatureFlagService extends BaseYCService<NonprofitFeatureFlagsState> {

  constructor (
    private nonprofitFeatureFlagResources: NonprofitFeatureFlagsResources
  ) {
    super();
  }

  get nonprofitFeatureFlags (): NonprofitFeatureFlag[] {
    return this.get('nonprofitFeatureFlags');
  }

  /**
   * Get and set nonprofit feature flags.
   */
  setNonprofitFeatureFlags (): Observable<NonprofitFeatureFlag[]> {
    return this.nonprofitFeatureFlagResources.getNonprofitFeatureFlags()
      .pipe(
        tap(r => this.set('nonprofitFeatureFlags', r))
      );
  }

  isNonprofitFeatureEnabled (featureFlagName: FeatureFlagName): boolean {
    return (this.nonprofitFeatureFlags.find(x => x.name === featureFlagName)?.enabled || false);
  }
}
